// Utils
import processError from './processError';
import addUserId from './addUserId';
import globalLogger from '../logger/logger';

// Constants
import { ROLLBAR_LEVELS } from './rollbarConstants';

const logger = globalLogger.createChannel('rollbar');

const getRollbar = () => {
    try {
        return window.Rollbar;
    } catch (err) {
        // Sensitive data audit: SAFE — Only error object for service initialization, no user data
        logger.error('Failed to retrieve Rollbar instance', err);
        return null;
    }
};

export const setRollbarUserId = (userId) => {
    const rollbar = getRollbar();

    if (!rollbar) return;

    rollbar.configure({
        payload: {
            person: {
                id: userId,
            },
        },
    });
};

export const setRollbarApplicationPlatform = (applicationPlatform) => {
    const rollbar = getRollbar();

    if (!rollbar) return;

    rollbar.configure({
        payload: {
            custom: {
                applicationPlatform: applicationPlatform,
            },
        },
    });
};

/**
 * @deprecated - use logger.error() instead. This will be removed once we have a common log interface.
 */ 
export const manuallyReportError = (args) => {
    const { errorMessage, error = {}, sensitive, custom, level = ROLLBAR_LEVELS.ERROR, getState } = args;

    const rollbar = getRollbar();

    if (!rollbar) return;

    const levelFn = !!rollbar[level] ? level : ROLLBAR_LEVELS.ERROR;

    let processedError = processError({ error, sensitive, custom });
    processedError = addUserId(processedError, getState);

    rollbar[levelFn](errorMessage, error, processedError);
};
